import { render, staticRenderFns } from "./DropdownList.vue?vue&type=template&id=722ec4f7&scoped=true&"
import script from "./DropdownList.vue?vue&type=script&lang=ts&"
export * from "./DropdownList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722ec4f7",
  null
  
)

export default component.exports